export default async function parseJsonResponseBody(
  response: Response,
): ReturnType<typeof response.json> {
  if (response.status === 204) {
    return;
  }
  return response.json();
}
